import { render } from "./LanguagesSection.vue?vue&type=template&id=d2b4df82"
import script from "./LanguagesSection.vue?vue&type=script&lang=js"
export * from "./LanguagesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__